/* jshint esversion: 6 */
import React from 'react';
import Sidebar from 'app/components/common/SideBar.jsx';
import Content from 'app/components/common/Content.jsx';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import * as _ from "underscore";
import { Link } from 'react-router-dom';
import { Breakpoint } from 'react-socks';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';
import AccessoryModal from 'app/components/PostingTool/AccessoryModal.jsx';
import FeatureCallout from 'app/components/common/FeatureCallout.jsx';

class Welcome extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            version: (this.props.user.detail.id) % 2 ? 'A 02132025' : 'B 02132025'
        }
        this.onTileClick = this.onTileClick.bind(this);

    }

    componentDidMount() {
        let onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null;

        if (this.props.recordEvent && onboarding) {
            this.props.recordEvent({
                pub_id: this.props.user.detail.id,
                event_name: 'Welcome Modal - View',
                event_data: {
                    version: this.state.version
                }
            });
        }
    }

    onTileClick(option) {
        let onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null;

        if (this.props.recordEvent && onboarding) {
            this.props.recordEvent({
                pub_id: this.props.user.detail.id,
                event_name: 'Welcome Modal - Tile Click',
                event_data: {
                    tile: option.title
                }
            });
        }
        this.props.router.navigate(option.link);
    }

    render() {
        let welcomeContent = null,
            imgPath = this.props.app.config.assetsUrl + "/" + this.props.app.config.imageUrl,
            optionButtons = [
                {
                    title: 'Post RSS Feed',
                    icon: `${imgPath}svg-logos/feed-welcome.svg`,
                    desc: 'Post RSS feed to social media',
                    link: '/content/feed?feed=true&welcome'
                },
                {
                    title: 'Create New Post',
                    icon: 'icon ion-edit',
                    desc: 'Create and schedule a social media post',
                    link: '/content/post'
                },
                {
                    title: 'Cross Post Content',
                    icon: 'icon ion-android-share-alt',
                    desc: 'Cross post between social platforms',
                    link: '/content/feed?social=true&welcome'
                },
                {
                    title: 'Generate AI Posts',
                    icon: 'icon ion-ios-color-wand',
                    desc: 'Use AI to generate social media posts',
                    link: '/content/post?helper'
                }
            ],
        cancelAction = (source) => {
            let cancelSource = 'Close button',
                onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null;

            if (typeof source === "string") {
                cancelSource = source;
            }
            if (this.props.recordEvent && onboarding) {
                this.props.recordEvent({
                    pub_id: this.props.user.detail.id,
                    event_name: 'Welcome Modal - Close',
                    event_data: {
                        source: cancelSource
                    }
                });
            }
            this.props.router.navigate('/content/feed');
        };

        let testCopy = 'What would you like to do today?';

        if (this.state.version.match("B")) {
            testCopy = 'What do you want to post?'
        }

        welcomeContent = (
            <div className="welcome-committee">
                <div className="title">Welcome <span>{String.fromCodePoint(0x1F44B)}</span></div>
                <div className="proposition">{testCopy}</div>
                <div className="options">
                    {optionButtons.map((option, i) => {
                        return (
                            <div key={i} className="welcome-option" onClick={() => {
                                this.onTileClick(option);
                            }}>
                                <div className="option-title">{option.title}</div>
                                <div className="option-graphic">
                                    {option.icon.match(/svg/) ? (
                                        <img src={option.icon}/>
                                    ) : (
                                        <i className={option.icon}/>
                                    )}
                                </div>
                                <div className="option-desc">
                                    {option.desc}
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className="feature-wrapper">
                    <FeatureCallout
                        {...this.props}
                        onClick={() => {
                            this.props.recordEvent({
                                pub_id: this.props.user.detail.id,
                                event_name: 'Welcome Modal - Promo Feature Click',
                                event_data: {
                                    tile: 'Instagram Input'
                                }
                            });
                            
                            this.props.router.navigate('/share/automate/new/inputs/instagram');
                        }}/>
                </div>
                <div className="none-of-the-above">
                    <Link to="/share/automations" onClick={() => {
                        // TODO log this separately from someone clicking "x"
                        cancelAction('Jump link');
                    }}>See popular automations</Link>
                </div>
            </div>
        );

        return (
            <div>
                <Breakpoint desktop only>
                    <Sidebar navItems={[
                        {
                            iconClass: 'fa fa-share sidebar-icon',
                            label: 'Add Feed',
                            labelClass: 'sidebar-label',
                            link: '/content/feed',
                            isHeader: false,
                            manualActive: false
                        },
                        {
                            iconClass: 'icon ion-ios-bolt-outline sidebar-icon',
                            label: 'Import/Discover',
                            labelClass: 'sidebar-label',
                            link: '/content/import',
                            isHeader: false
                        },
                        {
                            iconClass: 'icon ion-log-in sidebar-icon',
                            label: 'WP Connections',
                            labelClass: 'sidebar-label',
                            link: '/content/connections',
                            isHeader: false
                        },
                        {
                            iconClass: 'icon ion-ios-upload-outline sidebar-icon',
                            label: 'Import CSV',
                            labelClass: 'sidebar-label',
                            link: '/content/csv',
                            isHeader: false
                        }
                    ]} />
                </Breakpoint>
                <AccessoryModal 
                    cancelAction={cancelAction}
                    mode="welcome"
                    content={welcomeContent}/>
                <Content/>
            </div>
        );
        
    }
}

Welcome.displayName = "Welcome";

export default ComponentWithContext(Welcome);